const actions = {
   SET_GALLERY_MEDIA : "SET_GALLERY_MEDIA",
   SET_SINGLE_FEATURES : "SET_SINGLE_FEATURES",
  };
  
  export default actions;
  